import type { VoidComponent } from "solid-js";
import { createMemo, For, Show } from "solid-js";
import type { Role } from "../../../state/role";
import Wizard from "../../../components/modal/Wizard";
import { useCurrentModal } from "../../../components/modal/ModalManager";
import { keyFromSelector } from "i18next";
import { IconTile } from "../../../components/icon/IconTile";
import { useTranslation } from "../../../state/i18n";
import Text from "../../../components/text/Text";
import { PERMISSION_CATEGORY_TRANSLATION_KEYS, PERMISSION_DEFINITIONS } from "../../../state/Permission";
import { isEmpty } from "lodash-es";

type ViewRoleModalProps = {
  role: Role;
};

const ViewRoleModal: VoidComponent<ViewRoleModalProps> = (props) => {
  const { t } = useTranslation();
  const { close } = useCurrentModal();

  const rolePermissionSet = createMemo(() => new Set(props.role.permissions));

  return (
    <Wizard
      title={t(($) => $.VIEW_ROLE_MODAL_TITLE)}
      content={() => (
        <div class="flex flex-col gap-6 px-1 pt-4">
          <For each={PERMISSION_DEFINITIONS}>
            {(categoryGroup) => {
              const filteredPermissions = categoryGroup.permissions.filter(({ type }) => rolePermissionSet().has(type));

              return (
                <Show when={!isEmpty(filteredPermissions)}>
                  <div>
                    <h3
                      id={`permission-category-${categoryGroup.category}`}
                      class="px-3 pt-2.5 pb-0.5 text-header-md text-secondary"
                    >
                      {t(PERMISSION_CATEGORY_TRANSLATION_KEYS[categoryGroup.category])}
                    </h3>
                    <ul aria-labelledby={`permission-category-${categoryGroup.category}`}>
                      <For each={filteredPermissions}>
                        {(definition) => (
                          <li class="flex items-center gap-1.5 px-3 py-2.5">
                            <IconTile icon={definition.icon} size="sm" border />
                            <div class="flex min-w-0 flex-col">
                              <Text truncate text={t(definition.name)} class="text-base-medium text-primary" />
                              <Text
                                truncate
                                text={t(definition.description)}
                                class="text-base-regular text-secondary"
                              />
                            </div>
                          </li>
                        )}
                      </For>
                    </ul>
                  </div>
                </Show>
              );
            }}
          </For>
        </div>
      )}
      footer={{
        confirm: {
          label: keyFromSelector(($) => $.VIEW_ROLE_MODAL_ACTIONS_CLOSE_LABEL),
          action: async () => close(),
          disabled: false,
        },
        showCloseButton: false,
      }}
    />
  );
};

export default ViewRoleModal;
